import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/ashtakavarga-calculator/page.tsx");
